// Read-only summary shown before the consolidated year-end approval.
(function registerYearClosingFinalReview(global) {
  const list = (value) => Array.isArray(value) ? value : [];
  const number = (value) => Number.isFinite(Number(value)) ? Number(value) : 0;
  const sum = (rows, read) => Math.round(rows.reduce((total, row) => total + number(read(row)), 0) * 100) / 100;

  const build = (state, year, effectiveTaxBasis) => {
    const yearKey = String(year);
    const register = state?.investmentRegister || {};
    const events = list(register.events).filter((event) => event?.status === 'posted' && String(event?.date || '').startsWith(yearKey));
    const annualStatements = list(register.documentAnalyses).flatMap((analysis) => list(analysis?.candidates)
      .filter((candidate) => candidate?.kind === 'annual_summary' && candidate?.status !== 'dismissed' && String(candidate?.facts?.date || '').startsWith(yearKey)));
    const taxBasis = effectiveTaxBasis || state?.taxReturnProcessByYear?.[yearKey]?.taxBasis || {};
    const manualPermanent = list(taxBasis.permanentDifferences), manualTemporary = list(taxBasis.temporaryDifferences);
    const permanent = [...manualPermanent, ...list(taxBasis.automaticPermanentDifferences)];
    const temporary = [...manualTemporary, ...list(taxBasis.automaticTemporaryDifferences)];
    const permanentAmount = sum(permanent, (row) => row?.kind === 'fradrag' ? -number(row.amount) : row.amount);
    const temporaryChange = sum(temporary, (row) => (number(row.rmAar) - number(row.smAar)) - (number(row.rmFjor) - number(row.smFjor)));
    const correctedEvents = events.filter((event) => Object.keys(event?.documentSource?.correctedFacts || {}).length > 0);
    const manualDifferences = [...manualPermanent, ...manualTemporary].filter((row) => !String(row?.id || '').startsWith('investment-'));
    const closingReview = register.closing?.[yearKey] || register.closing?.[Number(year)] || null;
    const overrideLabels = [
      ...correctedEvents.map((event) => String(event.reference || event.id || 'Korrigert investeringshendelse')),
      ...manualDifferences.map((row) => String(row.label || row.desc || row.id || 'Manuell skatteforskjell')),
      ...(String(closingReview?.note || '').trim() ? [String(closingReview.note).trim()] : []),
    ];

    return {
      investment: {
        applicable: events.length > 0 || annualStatements.length > 0 || list(register.instruments).length > 0,
        eventCount: events.length,
        accountingGainLoss: sum(events, (event) => event?.result?.bookProfit),
        taxGainLoss: sum(events, (event) => event?.result?.taxProfit),
      },
      annualStatements: {
        count: annualStatements.length,
        reviewed: annualStatements.filter((candidate) => Boolean(candidate?.annualReview)).length,
      },
      differences: {
        permanentCount: permanent.length,
        permanentAmount,
        temporaryCount: temporary.length,
        temporaryChange,
        temporaryAmount: sum(temporary, (row) => number(row.rmAar) - number(row.smAar)),
        incomeAdjustment: Math.round((permanentAmount - temporaryChange) * 100) / 100,
      },
      overrides: { count: overrideLabels.length, labels: overrideLabels.slice(0, 5) },
    };
  };

  global.PlummeYearClosingFinalReview = { build };
})(window);
